import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../ui/Icon';
import { filesActions } from '../../store';

const formatSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const getFileIcon = (type) => {
  if (type?.includes('pdf')) return { icon: 'FileText', color: '#ef4444' };
  if (type?.includes('word') || type?.includes('document')) return { icon: 'FileType', color: '#3374ff' };
  if (type?.includes('sheet') || type?.includes('excel')) return { icon: 'Table', color: '#10b981' };
  if (type?.includes('presentation') || type?.includes('powerpoint')) return { icon: 'Presentation', color: '#f59e0b' };
  if (type?.startsWith('image/')) return { icon: 'Image', color: '#8b5cf6' };
  return { icon: 'FileText', color: '#6b7280' };
};

const FileList = () => {
  const dispatch = useDispatch();
  const { uploadedFiles } = useSelector(s => s.files);

  if (uploadedFiles.length === 0) return null;

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-bold" style={{ color: 'var(--text-primary)' }}>
          Uploaded Files ({uploadedFiles.length})
        </h4>
        <button onClick={() => dispatch(filesActions.clearFiles())}
          className="text-xs font-medium transition-colors hover:text-red-500"
          style={{ color: 'var(--text-muted)' }}>
          Clear all
        </button>
      </div>

      <div className="space-y-2">
        <AnimatePresence>
          {uploadedFiles.map((file, i) => {
            const fi = getFileIcon(file.type);
            return (
              <motion.div
                key={`${file.name}-${i}`}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20, height: 0 }}
                transition={{ duration: 0.25, delay: i * 0.05 }}
                className="flex items-center gap-3 p-3 rounded-xl group"
                style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-light)' }}
              >
                {/* Thumbnail or Icon */}
                {file.preview ? (
                  <img src={file.preview} alt="" className="w-10 h-10 rounded-lg object-cover" />
                ) : (
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center"
                    style={{ background: `${fi.color}12`, color: fi.color }}>
                    <Icon name={fi.icon} size={18} />
                  </div>
                )}

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate" style={{ color: 'var(--text-primary)' }}>{file.name}</p>
                  <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{formatSize(file.size)}</p>
                </div>

                {/* Remove */}
                <button onClick={() => dispatch(filesActions.removeFile(i))}
                  className="p-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-all hover:bg-red-50"
                  style={{ color: 'var(--text-muted)' }}>
                  <Icon name="X" size={14} />
                </button>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default FileList;
